import { get } from "./api_helper"

export const getCommonTaxAPI = () => get("config/tax")
